import React, { Fragment, useEffect, useState, useRef  } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { getForYouPosts, getGroupPhotos, getPostsByGroupId, set_ShowBottomSpinner } from '../actions/postActions';
import { toggleSideNav, setPage, add_To_Recent_History, toggleAuthModal, togglePostModal } from '../actions/navActions';
import { setAlert } from '../actions/alertActions';

// Layout Wrapper
import Layout from '../components/layout/Layout';

// components
import { Button } from '@material-ui/core';
import Spinner from '../components/common/Spinner';
import TweetBox from '../components/TweetBox/TweetBox';
import Post from '../components/Post/Post';
import GettingStarted from '../components/common/GettingStarted';
import HowItWorks from '../components/common/HowItWorks';
import FAQ_Container from '../components/common/FAQ_Container';
import Contact_Widget from '../components/Widgets/Contact_Widget';
import AboutSection from './AboutPage/AboutSection';
import ActivitySection from './AboutPage/ActivitySection';

// Logic Only Components
import TriggerAlerts from '../sideEffects/TriggerAlerts/TriggerAlerts';
import TriggerSideEffects from '../sideEffects/TriggerSideEffects';

// Icons
import CloseIcon from '@material-ui/icons/Close';
import SportsFootballIcon from '@material-ui/icons/SportsFootball';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import ApartmentIcon from '@material-ui/icons/Apartment';

import phone_preview from '../utils/imgs/phone_preview.png'
import STUDENT_ONLY_TYPES from '../utils/constant_variables/STUDENT_ONLY_TYPES';
import PeopleSection from './AboutPage/PeopleSection';
import { HorizontalNav } from '../components/common/HorizontalNav';
import FILTER_OPTIONS from '../utils/constant_variables/FILTER_OPTIONS';

const FeedPage = ({
    getForYouPosts,
    getPostsByGroupId,
    getGroupPhotos,
    set_ShowBottomSpinner,
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    toggleAuthModal,
    togglePostModal,
    setAlert,
    auth, 
    nav: { 
        sideNav, 
        page, 
        postModal,
        website,
        website_loading
    },
    post,
    history
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Check if user is verified
    const [checkedVerification, setCheckedVerification] = useState(false);
    const [checkedVerification_schoolEmail, setCheckedVerification_schoolEmail] = useState(false);

    // Posts
    const [postList, setPostList] = useState([]);
    const [gotPosts, setGotPosts] = useState(false);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // Inifite scroll
    const [lastPageDoc, setLastPageDoc] = useState(null);
    const [noMorePosts, setNoMorePosts] = useState(false);
    const [showBottomSpinner, setShowBottomSpinner] = useState(false)
    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);

    // URL and filter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("filter");
    const activeTab = url.searchParams.get("show");
    const intent_filter = url.searchParams.get("intent");
    const hostname = window.location.hostname;

    const SPACE_HEIGHT = 250; // Hieght of className 'no-rides' which is a spacer to make sure user can always scroll down
    
    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;
    const notFullScreen = windowWidth <= 1170;

    // Listen for window resize event and update window width state
    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };
    
    useEffect(() => {
        setPage('home');
        add_To_Recent_History(url.pathname);  // current url
        
        // Display alert if the filter parameter is set to 'notify-posted'
        if(filter && filter === 'notify-posted') {
            setAlert('Your post was sent', 'okay')
        } 

    }, [filter]);

    // Trigger get initial posts
    useEffect(() => {
        if(website_loading) return;

        setGotPosts(false);

        if(website) {
            fetchGroupPosts();
        } else {
            fetchPosts_ForYou();
        }

    }, [website, website_loading]);

    // Render posts list for display
    useEffect(() => {

        renderPostList();
    }, [post.posts, canLoadMore]);

    // -- Analytics stuff -- 

    // Track if Action has been tracked yet, (stores postId & current index of display ads)
    const trackedViews = useRef(new Set());
    const trackedDms = useRef(new Set());
    const trackedCopiedLinks = useRef(new Set());
    const trackedLinkClicks = useRef(new Set());
    const sponsoredIndex = useRef(0);
    let analyticsMetaData = {
        trackedViews,
        trackedDms,
        trackedCopiedLinks,
        trackedLinkClicks,
        sponsoredIndex,
        userId: auth?.user?._id
    }

    // -- End: Analytics stuff --

    // Get initial set of posts
    const fetchPosts_ForYou = () => {

        getForYouPosts({ analyticsMetaData, filter_tags: intent_filter ? [intent_filter] : null  });
        setGotPosts(true);
    }

    // -- Custom Url Logic ---

    const fetchGroupPosts = () => {

        if(website) {
            if(activeTab === 'photos') {
                // Load posts with photos if on the 'photos' tab
                getGroupPhotos({ group_id: website._id })
                setGotPosts(true);
            } else if(activeTab !== 'about') {
                // Load all posts
                getPostsByGroupId({ group_id: website._id, filter_tags: intent_filter ? [intent_filter] : null });
                setGotPosts(true);
            } 
        }
    }

    // -- END: Custom Url Logic --

    // Function to load more paginated posts
    const loadMore = async (lastPage_doc) => {
        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);

            // Show spinner
            set_ShowBottomSpinner(true);

            if(!website_loading) {
                if(website) {
                    if(activeTab === 'photos') {
                        // Load posts with photos if on the 'photos' tab
                        await getGroupPhotos({ group_id: website._id, lastPageDoc: lastPage_doc })
                    } else if(activeTab !== 'about') {
                        // Load all posts
                        await getPostsByGroupId({ group_id: website._id, lastPageDoc: lastPage_doc, filter_tags: intent_filter ? [intent_filter] : null })
                    }
                } else {
                    await getForYouPosts({ lastPageDoc: lastPage_doc, analyticsMetaData, filter_tags: intent_filter ? [intent_filter] : null })
                }
            }
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }
    }

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight} = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");

                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {

                // scrolling up - show top nav
                setScrollDirection("up");

                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more posts are met
        if (newScrollY >= scrollHeight - (SPACE_HEIGHT+1) && !post.show_bottom_spinner && !post.no_more_posts && post.posts.length > 0 && canLoadMore) {
            console.log('scrolling');
            loadMore(post.last_page_doc);
        }
    }

    // Handle create Post Modal Toggle
    const handleToggle_PostModal = () => {
        if(auth.user) {
            togglePostModal();
        } else {
            toggleAuthModal('post');
        }
    }

    // Check if user is verified. If no redirect to verify page
    if(auth.user && !auth.user.verified && !checkedVerification) {
        window.location.href = '/verify';

        setCheckedVerification(true);
    }

    // Check if user's school email is verified. If no redirect to school email page (only for 'students only' groups)
    if(auth.user && !auth.user.school_verified && !checkedVerification_schoolEmail && STUDENT_ONLY_TYPES.includes(website?.privacy?.toLowerCase())) {
        window.location.href = '/settings/account/school_email';

        setCheckedVerification_schoolEmail(true);
    }

    const renderPostList = async () => {
        setPostList([]);

        if((post.posts === null && auth.loading) || !gotPosts) {
            setPostList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(post.posts.length > 0) {
                post.posts.map(post_doc => {
                    const renderPostRecursive = (postComments, parentPost) => {
                        
                        const lastComment = postComments[postComments.length - 1]; // Get the last comment
    
                        return (
                            <Fragment>
                                <Post key={lastComment._id} postDoc={lastComment} parentPost={parentPost} />
    
                                {/* Recursive call to render comments of comments */}
                                {lastComment.commentsOfComments && lastComment.commentsOfComments.length > 0 && (
                                    <div className="comments-of-comments">
                                    {renderPostRecursive(lastComment.commentsOfComments, lastComment)}
                                    </div>
                                )}
                            </Fragment>
                        );
    
                    };
    
                    if(post_doc.commentsOfComments && post_doc.commentsOfComments.length > 0) {
                        setPostList(postList => [...postList, (
                            <div className='post_container'>
                                <Post key={post_doc._id} postDoc={post_doc} />
    
                                {renderPostRecursive(post_doc.commentsOfComments, post_doc)}
                            </div>
                        )])
                    } else {
                        setPostList(postList => [...postList, (
                            <Post key={post_doc._id} postDoc={post_doc} />
                        )])
                    }
                }) 
            } else {
                if(intent_filter) {
                    setPostList(postList => [...postList, (
                        <div className="no-posts-container">
                            <div className="no-chats">
                                <h1 className='placeholder_title'>No posts yet</h1>
                                <p className='placeholder_text'>Couln't find anything under that filter.</p>
    
                                <Button 
                                    onClick={handleToggle_PostModal}
                                    variant="outlined" 
                                    className="sidebar__tweet minWidth black"
                                >
                                    Create A Post
                                </Button>
                                
                            </div>
                        </div>
                    )])
                } else {
                    setPostList(postList => [...postList, (
                        <div className="no-posts-container">
                            <div className="no-chats">
                                <h1 className='placeholder_title'>Be the first...</h1>
                                <p className='placeholder_text'>...to create a post, it's so easy!</p>
    
                                <Button 
                                    onClick={handleToggle_PostModal}
                                    variant="outlined" 
                                    className="sidebar__tweet minWidth black"
                                >
                                    Create A Post
                                </Button>
                                
                            </div>
                        </div>
                    )])
                }
            }
        } 

        setGotPosts(true);
    }

    // Function to handle Mixpanel analytics
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Feed Page View");
    }

    // Trigger Mixpanel analytics on initial render in production mode
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        handleMixpanel();
        setSentMixpanel(true);
    }

    return (
        <Fragment>
            {/* // -- Trigger Alerts on page load --
            // ----------------------------------
            // after performing an action in another part of the app, user might get redirect to this page.
            // show alerts to user, on their screen, that are pending in localStorage */}

            <TriggerAlerts />

            {/* // -- Trigger Side Effects on page load --
            // ----------------------------------
            // Make sure user account passes all checks and trigger any other system audits */}

            <TriggerSideEffects />

            {/* // -- END: Trigger Alerts on page load -- */}
            
            <Layout handleScroll={handleScroll} sideNav={sideNav} handleSlideMenu={toggleSideNav} page="home">
                
                {auth.loading || website_loading ? (
                    <Fragment>
                        <Spinner />
                    </Fragment>
                ) : !auth.isAuthenticated ? (
                    <Fragment>
                        {website && (
                            <div style={{padding: '12px 16px', background: '#fff'}} className="btnRow">
                                <Button 
                                    onClick={toggleAuthModal}
                                    variant="outlined" 
                                    className="sidebar__tweet ghost minWidth noMargin"
                                >
                                    Log In
                                </Button>
                                <Button 
                                    onClick={toggleAuthModal}
                                    variant="outlined" 
                                    className="sidebar__tweet minWidth noMargin"
                                >
                                    Join Group
                                </Button>
                            </div>
                        )}
                        {!website && (
                            <div className="no-rides" style={{paddingTop: '20px'}}>
                                <h1 className='placeholder_title'>Welcome To Buy Sell App.</h1>
                                <p className='placeholder_text'>The simplest way to Buy & Sell.</p>

                                <Button 
                                    onClick={() => toggleAuthModal()}
                                    variant="outlined" 
                                    className="sidebar__tweet minWidth black"
                                >
                                    Click to Sign In
                                </Button>

                                <div className='search_imgContainer' style={{display:'flex', justifyContent:'center', marginTop: '40px'}}>
                                    <img style={{maxWidth:'100%'}} src={phone_preview} />
                                </div>
                            </div>
                        )}

                        <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                            <HowItWorks hide_title={!website} />
                        </div>

                        {!website ? (
                            <div className="post noHighlight">
                                <GettingStarted hide_actionBtn />
                            </div>
                        ) : (
                            <Fragment>
                                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                                    <AboutSection />
                                </div>
            
                                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                                    <ActivitySection />
                                </div>
                            </Fragment>
                        )}

                        <FAQ_Container />

                        {notFullScreen && <Contact_Widget notFullScreen={notFullScreen} />}

                        <div className="no-rides"></div>
                    </Fragment>
                ) : (
                    <Fragment>

                        {!website ? (
                            <div className="feed_headerTabs">
                                <div className='active' onClick={() => window.location = `${window.location.pathname}${filter ? `?q=${filter}` : ''}`}>
                                    <h3>For You</h3>
                                    <div className="block__underline"></div>
                                </div>
                                <div onClick={() => window.location = `/following`}>
                                    <h3>Following</h3>
                                    <div className="block__underline"></div>
                                </div>
                            </div>
                        ) : (
                            <div className="feed_headerTabs">
                                <div className={`${(activeTab === null || activeTab === undefined || activeTab === 'posts') && 'active'}`} onClick={() => window.location = `${window.location.pathname}`}>
                                    <h3>Posts</h3>
                                    <div className="block__underline"></div>
                                </div>
    
                                <div className={`${(activeTab && activeTab === 'photos') && 'active'}`} onClick={() => window.location = `/photos`}>
                                    <h3>Photos</h3>
                                    <div className="block__underline"></div>
                                </div>

                                <div className={`${(activeTab && activeTab === 'about') && 'active'}`} onClick={() => window.location = `/about`}>
                                    <h3>About</h3>
                                    <div className="block__underline"></div>
                                </div>
                            </div>
                        )}

                        {website && activeTab === 'about' ? (
                            <Fragment>
                                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                                    <AboutSection />
                                </div>

                                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                                    <ActivitySection />
                                </div>

                                <div style={{borderTop: '1px solid #e6ecf0'}} className="post noHighlight">
                                    <PeopleSection />
                                </div>

                                {/* Spacer */}
                                <div className="no-rides"></div>

                            </Fragment>
                        ) : (
                            <Fragment>
                                {/* Render GettingStarted component if user is authenticated and profile is not set up */}
                                {!auth.user.profile_set_up && (
                                    <div className="post noHighlight">
                                        <GettingStarted />
                                    </div>
                                )}

                                {/* Filter Options */}
                                <div style={{margin: '13px 0 3px'}}>
                                    <HorizontalNav>
                                        {intent_filter && (
                                            <div
                                                onClick={() => {
                                                    // Create a copy of the current url object
                                                    const current_url = new URL(url_filter);
                                                    // remove any url variables 
                                                    current_url.searchParams.delete('intent');
                                                    // reload page
                                                    window.location.href = current_url.href;
                                                }}
                                                style={{
                                                    // display: 'inline-block',
                                                    // alignSelf: 'stretch',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    height: '33px',
                                                    minWidth: '33px',
                                                    borderRadius: '9999px',
                                                    backgroundColor: '#f3f4f6',
                                                    color: '#4b5563',
                                                    transition: 'background-color 0.15s ease-in-out',
                                                    cursor: 'pointer',
                                                    marginLeft: '5px',
                                                    marginRight: '5px'
                                                }}
                                                className='icon_20'
                                            >
                                                <CloseIcon />
                                            </div>
                                        )}
                                        {FILTER_OPTIONS.map(item => {
                                            const isActive = item._id === intent_filter;
                                            return (
                                                <div
                                                    onClick={() => {
                                                        // Create a copy of the current url object
                                                        const current_url = new URL(url_filter);
                                                        if(!isActive) {
                                                            // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                            current_url.searchParams.set('intent', item._id?.trim());
                                                        } else {
                                                            // add this filter's ID to the url variables (automatically handles ? or & formatting)
                                                            current_url.searchParams.delete('intent');
                                                        }
                                                        // reload page
                                                        window.location.href = current_url.href;
                                                    }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '0 16px',
                                                        boxSizing: 'border-box',
                                                        height: '33px',
                                                        minWidth: 'fit-content',
                                                        borderRadius: '9999px',
                                                        backgroundColor: isActive ? '#3b82f6' : '#f3f4f6',
                                                        color: isActive ? '#ffffff' : '#4b5563',
                                                        fontSize: '14px',
                                                        fontWeight: 600,
                                                        fontFamily: 'sans-serif',
                                                        transition: 'background-color 0.15s ease-in-out',
                                                        cursor: 'pointer',
                                                        marginLeft: '5px'
                                                    }}
                                                >
                                                    {item.name}
                                                </div>
                                            )
                                        })}
                                        {/* Football schedule option */}
                                        <div
                                            onClick={() => {
                                                window.location.href = `/schedule/football`;
                                            }}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 16px',
                                                boxSizing: 'border-box',
                                                height: '33px',
                                                minWidth: 'fit-content',
                                                borderRadius: '9999px',
                                                backgroundColor: '#f3f4f6',
                                                color: '#4b5563',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                fontFamily: 'sans-serif',
                                                transition: 'background-color 0.15s ease-in-out',
                                                cursor: 'pointer',
                                                marginLeft: '5px'
                                            }}
                                        >
                                            <span className='icon_16' style={{marginRight: '5px'}}>
                                                <SportsFootballIcon />
                                            </span>
                                            Football schedule
                                        </div>
                                        {/* Lease Takeover option */}
                                        {(website?.search_tags?.includes('college') || website?.search_tags?.includes('colleges')) && (
                                            <div
                                                onClick={() => {
                                                    window.location.href = `/category/lease-takeover`;
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    padding: '0 16px',
                                                    boxSizing: 'border-box',
                                                    height: '33px',
                                                    minWidth: 'fit-content',
                                                    borderRadius: '9999px',
                                                    backgroundColor: '#f3f4f6',
                                                    color: '#4b5563',
                                                    fontSize: '14px',
                                                    fontWeight: 600,
                                                    fontFamily: 'sans-serif',
                                                    transition: 'background-color 0.15s ease-in-out',
                                                    cursor: 'pointer',
                                                    marginLeft: '5px'
                                                }}
                                            >
                                                <span className='icon_16' style={{marginRight: '5px'}}>
                                                    <ApartmentIcon />
                                                </span>
                                                Lease Takeover
                                            </div>
                                        )}
                                        {/* Categories option */}
                                        <div
                                            onClick={() => {
                                                window.location.href = `/categories`;
                                            }}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                padding: '0 16px',
                                                boxSizing: 'border-box',
                                                height: '33px',
                                                minWidth: 'fit-content',
                                                borderRadius: '9999px',
                                                backgroundColor: '#f3f4f6',
                                                color: '#4b5563',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                fontFamily: 'sans-serif',
                                                transition: 'background-color 0.15s ease-in-out',
                                                cursor: 'pointer',
                                                marginLeft: '5px'
                                            }}
                                        >
                                            <span className='icon_16' style={{marginRight: '5px'}}>
                                                <LocalMallIcon />
                                            </span>
                                            Categories
                                        </div>
                                        
                                    </HorizontalNav>
                                </div>

                                {/* Render TweetBox component if user is authenticated and postModal is false */}
                                {!postModal && !intent_filter ? (
                                    <TweetBox isTablet={isMobile} mobile_redirect={isMobile} />
                                ) : null}

                                <div style={{background: '#e6ecf0', height: '1px'}}></div>
                                
                                {/* Render the postList */}
                                {postList}

                                {/* Render a spinner at the bottom if there are more posts to load */}
                                {post.show_bottom_spinner && !post.no_more_posts && <Spinner />}
                                {/* <button onClick={loadMore}>More Posts</button> */}
                                
                                {/* Display a message when there are no more posts */}
                                <div className="no-rides">{(post.no_more_posts && post.posts.length !== 0) && "You've reached the end."}</div>
                            </Fragment>
                        )}

                    </Fragment>
                )}

            </Layout>
        </Fragment>
    )
}

FeedPage.propTypes = {
    getForYouPosts: PropTypes.func.isRequired,
    getPostsByGroupId: PropTypes.func.isRequired,
    getGroupPhotos: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    toggleAuthModal: PropTypes.func.isRequired,
    togglePostModal: PropTypes.func.isRequired,
    setAlert: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired, // Object prop representing the authentication state of the user
    ad: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    post: state.post,
    nav: state.nav,
    auth: state.auth,
    ad: state.ad
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    getForYouPosts,
    getPostsByGroupId,
    getGroupPhotos,
    set_ShowBottomSpinner,
    toggleSideNav, 
    setPage, 
    add_To_Recent_History,
    toggleAuthModal,
    togglePostModal,
    setAlert
})(FeedPage);
